import { localize, extend } from 'vee-validate';

import en from 'vee-validate/dist/locale/en.json';
import * as veeRules from 'vee-validate/dist/rules';

Object.keys(veeRules).forEach(k => extend(k, veeRules[k]));

import '@/common/rules';

localize('en', en.messages);

import en_common from '../commons/en';
import zhCN_common from '../commons/zh_CN';
import zhTW_common from '../commons/zh_TW';

import en_labels from '../labels/en';
import zh_labels from '../labels/zh';

import en_rules from './en';
import zh_rules from './zh';

/*let lang = store.getters.getLang;
if(!lang || !lang.code){
  // lang = tool.getBrowserLang();
  if(/\w+-(\w+)/.test(lang)){
    let arr = lang.split("-");
    arr[1] = RegExp.$1.toUpperCase();

    lang = arr.join("_");
    arr = null;
  }
}else{*/
  /*}*/

let langObj = localStorage.getItem('lang');
langObj = JSON.parse(langObj);
let lang = (langObj && langObj.code) ? langObj.code : 'en_US';

let common, labels, messages;
switch (lang) {
  case 'en_US':
    common = en_common;
    messages = en_rules;
    // labels = lowercase(en_labels);
    labels = en_labels;
    break;
  case 'zh_CN':
    common = zhCN_common;
    messages = zh_rules;
    labels = zh_labels;
    break;
  case 'zh_TW':
    common = zhTW_common;
    messages = zh_rules;
    labels = zh_labels;
    break;
}

let obj = {
  messages: {
    ...common,
  },
  names: {
    ...labels,
  },
  fields: {
    ...messages,
  },
};

switch (lang) {
  case 'en_US':
    localize('en', obj);
    break;
  case 'zh_CN':
    localize('zh_CN', obj);
    break;
  case 'zh_TW':
    localize('zh_TW', obj);
    break;
}

function lowercase(obj) {
  for (let prop in obj) {
    if (typeof obj[prop] === 'string') {
      obj[prop] = obj[prop].toLowerCase();
    }
    if (typeof obj[prop] === 'object') {
      lowercase(obj[prop]);
    }
  }
  return obj;
}

export default obj;
